module.exports = __webpack_public_path__ + "media/newstyle/images/100-mil-book-9cefab6c974c84c2e6167123bcb3564a.svg";